// Module
var code = `<div class="text-right">
	<!-- ko if: \$data.buttonsGroup && \$data.buttonsGroup().length > 0 -->
	<div class="btn-group" data-bind="foreach: buttonsGroup">
		<button class="btn btn-secondary" data-bind="css:{ disabled: \$data.disabled, active: \$data.active }, click: \$data.click, html: \$data.html"></button>
	</div>
	<!-- /ko -->
	<!-- ko if: \$data.buttonsMain && \$data.buttonsMain().length > 0 -->
	<!-- ko foreach: \$data.buttonsMain -->
	<button-extra params="disabled: (\$data.disabled?\$data.disabled:(\$data.isBusy || false)), click: function(data, e){ \$data.click(\$data, e); }, busy: \$data.isBusy || false, html: \$data.html, css: (\$data.css || 'btn btn-primary'), icon: \$data.icon, actions: \$data.actions"></button-extra>
	<!-- /ko -->
	<!-- /ko -->
</div>
`;
// Exports
export default code;